module.exports = __webpack_public_path__ + "static/assets/f1207802424428612503584b5258902c.png";